import { pick } from 'lodash';

let idCounter = 0;

const sectionEqualityProps = ['items', 'totalItems', 'itemHeight', 'itemClass', 'isItemLoaded'];

const flatSectionProps = sectionEqualityProps.concat(['isRowItem', 'renderItemComponent', 'loadMore', 'itemProps', 'itemKey', 'getItemStyle']);

/**
 * compare two sections collections
 * return true if they're equal in length or relevant props are the same
 */
export const areSectionsEqual = (sections, nextSections) => {
  let equal = false;

  if (sections.length === nextSections.length) {
    equal = !sections.find((s, i) => {
      const ns = nextSections[i];
      return sectionEqualityProps.find((p) => s[p] !== ns[p]);
    });
  }

  return equal;
};

/**
 * get a flat list of all sections
 */
const flattenSections = (
  sections //todo: use flatMap (when more support or polyfill)
) =>
  [].concat(
    ...sections.map((s) =>
      []
        .concat(s.top ? pick(s.top, flatSectionProps) : []) //keep order of sections
        .concat(pick(s, flatSectionProps))
        .concat(s.bottom ? pick(s.bottom, flatSectionProps) : [])
    )
  );

const calculateSectionCounters = (section, colCount, rows) => {
  const startRow = rows,
    totalItems = section.isRowItem ? colCount : section.totalItems,
    lastRowMissing = totalItems % colCount, //check how many items missing to fit the last row with items
    buffer = lastRowMissing ? colCount - lastRowMissing : 0, //we want to make sure each section begins on a new row
    count = totalItems + buffer,
    endRow = rows + Math.ceil(count / colCount) - 1,
    startIndex = startRow * colCount,
    endIndex = startIndex + count - 1; //includes the buffer

  return {
    totalItems, //how many items in the section (not including buffer)
    startRow, //first row index for this section
    endRow, //last row index for this section
    startIndex, //the first absolute index in this section
    endIndex, //the last absolute index in this section
    buffer, //the size of the buffer added to complete the last row
    bufferStartIndex: buffer && endIndex - (buffer - 1), //the index where the buffer starts
  };
};

const getCountersForSection = (section, colCount, rows, total) => {
  const counters = calculateSectionCounters(section, colCount, rows);

  rows = counters.endRow + 1;
  total += counters.totalItems + counters.buffer;

  return {
    section: {
      ...section,
      ...counters,
      id: `s${idCounter++}`, //unique id for this section
    },
    rows, //total rows
    total, //total items
  };
};

export default (sections, colCount) => {
  const flattened = flattenSections(sections);

  let total = 0,
    rows = 0;

  const data = flattened
    .map((section) => {
      let sectionData = null;

      if (section && (section.isRowItem || section.totalItems)) {
        //ignore sections that have totalItems = 0 unless isRowItem
        sectionData = getCountersForSection(section, colCount, rows, total);
        rows = sectionData.rows;
        total = sectionData.total;
      }

      return sectionData && sectionData.section;
    })
    .filter(Boolean); //filter out null items

  return {
    total,
    sections: data,
  };
};
